import React, { useEffect } from 'react'
import { useDataValue } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let isExternalPatient = useDataValue({
    context: 'appointment_overlay',
    path: 'is_external_patient_id',
    viewPath: props.viewPath,
  })
  let patientId = useDataValue({
    context: 'appointment_overlay',
    path: 'patient_id',
    viewPath: props.viewPath,
  })
  useEffect(() => {
    if (!isExternalPatient && !patientId && typeof props.onFocus === 'function')
      props.onFocus()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
